import React, {Component} from 'react';
import "./style.css";

export default class DirectTituloJanela extends Component {
  render() {
  return (
    <div className="directTituloJanela">
      <div className="divTitulo">
        {/* eslint-disable-next-line */}
        <a href={this.props.urlVoltar} className="iconeVoltar">
          <i class="material-icons">arrow_back_ios</i>
        </a>
        <h5 className="h5Titulo">
          {this.props.titulo !== undefined && this.props.titulo}
        </h5>
        {this.props.urlNovo !== undefined && (
          <div className="divDireita">
            <a
              href={this.props.urlNovo}
              className="saib-button-titulo-janela is-call-to-action iconeNovo"
            >
              <i class="material-icons">
                {this.props.iconeNovo !== undefined
                  ? this.props.iconeNovo
                  : "add"}
              </i>
              {this.props.textoIconeNovo !== undefined
                ? this.props.textoIconeNovo
                : "Criar"}
            </a>
          </div>
        )}
      </div>
    </div>
  );
  }
}
